import Swal from "sweetalert2";
import i18n from "i18next";

interface msg {
    detail: detail;
}

interface detail {
    msg: string | limit;
    type: string;
}

interface limit {
    creatable: boolean;
    quota: number;
    amount: number;
}

export const swal_util = {

    async show_question(title: string, text: string) {
        return Swal.fire({
            title: title,
            html: text,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: i18n.t("common.confirm"),
            cancelButtonText: i18n.t("common.cancel"),
        })
    },
    async show_error(text: string) {
        return Swal.fire({
            title: "ERROR",
            html: text,
            icon: "error",
            confirmButtonText: i18n.t("common.confirm"),
        });
    },
    async show_info(text: string) {
        return Swal.fire({
            title: "INFO",
            html: text,
            icon: "info",
            confirmButtonText: i18n.t("common.confirm"),
        });
    },
    async show_warning(text: string) {
        return Swal.fire({
            html: text,
            icon: "warning",
            confirmButtonText: i18n.t("common.confirm"),
        });
    },
    async show_success(text: string) {
        return Swal.fire({
            title: "SUCCESS",
            html: text,
            icon: "success",
            confirmButtonText: i18n.t("common.confirm"),
        });
    },
    async show_loading(text: string = i18n.t("swal.loadingDefault")) {
        return Swal.fire({
            title: "LOADING",
            html: text,
            allowOutsideClick: true,
            allowEscapeKey: false,
            showConfirmButton: false,
        });
    },
    async hide_loading() {
        return Swal.close();
    },
    async show_port_forwarding_error(res: object) {
        const data = res as msg
        if (data.detail.type === "duplicated_intern_port_error") {
            return swal_util.show_error("내부 포트가 이미 존재합니다.");
        } else if (data.detail.type === "fail_port_add_error") {
            return swal_util.show_error("포트 추가 실패했습니다.");
        } else if (data.detail.type === "not_allowed_port_add_error") {
            return swal_util.show_error("허용되지 않은 포트입니다.");
        } else if (data.detail.type === "exceeding_limit_error") {
            const limitData = data.detail.msg as limit
            return swal_util.show_error(`제한수 초과. 현재 갯수: ${limitData['amount']}, 허용 갯수: ${limitData['quota']}`);
        } else {
            return swal_util.show_error("포트 추가 실패.");
        }
    }
}